import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@tabipla/ui";

export function PrivacyPage() {
  const { t } = useTranslation();

  const sections = [
    "intro",
    "collection",
    "usage",
    "sharing",
    "storage",
    "rights",
    "cookies",
    "children",
    "changes",
    "contact",
  ];

  return (
    <div className="animate-fade-in py-12 sm:py-16">
      <div className="mx-auto max-w-3xl px-4">
        {/* Header */}
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-3xl font-bold sm:text-4xl">{t("privacy.title")}</h1>
          <p className="text-muted-foreground">{t("common.lastUpdated")}: 2026-01-29</p>
        </div>

        {/* Table of Contents */}
        <Card className="mb-8">
          <CardContent className="p-6">
            <h2 className="mb-4 font-semibold">目次</h2>
            <ol className="space-y-1 text-sm">
              {sections.map((section) => (
                <li key={section}>
                  <a
                    href={`#${section}`}
                    className="text-muted-foreground hover:text-primary hover:underline"
                  >
                    {t(`privacy.${section}.title`)}
                  </a>
                </li>
              ))}
            </ol>
          </CardContent>
        </Card>

        {/* Content */}
        <div className="space-y-8">
          {/* 1. Introduction */}
          <section id="intro">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.intro.title")}</h2>
            <p className="text-muted-foreground">{t("privacy.intro.content")}</p>
          </section>

          {/* 2. Collection */}
          <section id="collection">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.collection.title")}</h2>
            <p className="mb-3 text-muted-foreground">{t("privacy.collection.content")}</p>
            <ul className="list-inside list-disc space-y-2 text-muted-foreground">
              {(t("privacy.collection.items", { returnObjects: true }) as string[]).map(
                (item, i) => (
                  <li key={i}>{item}</li>
                )
              )}
            </ul>
          </section>

          {/* 3. Usage */}
          <section id="usage">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.usage.title")}</h2>
            <p className="mb-3 text-muted-foreground">{t("privacy.usage.content")}</p>
            <ul className="list-inside list-disc space-y-2 text-muted-foreground">
              {(t("privacy.usage.items", { returnObjects: true }) as string[]).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* 4. Sharing */}
          <section id="sharing">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.sharing.title")}</h2>
            <p className="mb-3 text-muted-foreground">{t("privacy.sharing.content")}</p>
            <ul className="list-inside list-disc space-y-2 text-muted-foreground">
              {(t("privacy.sharing.items", { returnObjects: true }) as string[]).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* 5. Storage */}
          <section id="storage">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.storage.title")}</h2>
            <p className="text-muted-foreground">{t("privacy.storage.content")}</p>
          </section>

          {/* 6. Rights */}
          <section id="rights">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.rights.title")}</h2>
            <p className="mb-3 text-muted-foreground">{t("privacy.rights.content")}</p>
            <ul className="list-inside list-disc space-y-2 text-muted-foreground">
              {(t("privacy.rights.items", { returnObjects: true }) as string[]).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* 7. Cookies */}
          <section id="cookies">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.cookies.title")}</h2>
            <p className="text-muted-foreground">{t("privacy.cookies.content")}</p>
          </section>

          {/* 8. Children */}
          <section id="children">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.children.title")}</h2>
            <p className="text-muted-foreground">{t("privacy.children.content")}</p>
          </section>

          {/* 9. Changes */}
          <section id="changes">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.changes.title")}</h2>
            <p className="text-muted-foreground">{t("privacy.changes.content")}</p>
          </section>

          {/* 10. Contact */}
          <section id="contact">
            <h2 className="mb-3 text-xl font-semibold">{t("privacy.contact.title")}</h2>
            <p className="text-muted-foreground">{t("privacy.contact.content")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
